import React, { useState, Fragment } from 'react'
import Field from 'components/AddOrEditFormPage/CustomForm/Field'
import MultiOptions from './MultiOptions'
import Checkbox from 'components/AddOrEditFormPage/CustomForm/Checkbox'
import {
  ExpansionPanel,
  ExpansionPanelSummary,
  Typography,
  ExpansionPanelDetails,
} from '@material-ui/core'
import { ExpandMore } from '@material-ui/icons'
import Warning from './Warning'

const Select = ({ isEditing, isDragging, item, index }) => {
  const [otherSelected, selectOther] = useState(false)
  const [idxSelected, selectIdx] = useState(null)

  return isEditing ? (
    <div style={{ paddingTop: 10, paddingBottom: 10 }}>
      <Field
        label="Question"
        property="label"
        statePath={state =>
          state.customForm.addOrEdit.sectionsByID[item.id].label
        }
        placeholder="Enter a question"
        sectionID={item.id}
      />
      <Field
        label="Description"
        property="description"
        statePath={state =>
          state.customForm.addOrEdit.sectionsByID[item.id].description
        }
        placeholder="Enter a description"
        sectionID={item.id}
      />
      <MultiOptions itemID={item.id} />
      <Checkbox
        label="Required"
        property="required"
        statePath={state =>
          state.customForm.addOrEdit.sectionsByID[item.id].field.required
        }
        type="field"
        sectionID={item.id}
      />
      <ExpansionPanel>
        <ExpansionPanelSummary expandIcon={<ExpandMore />}>
          <Typography style={{ fontSize: 15 }}>Advanced</Typography>
        </ExpansionPanelSummary>
        <ExpansionPanelDetails style={{ display: 'block' }}>
          <Checkbox
            label="Hidden"
            property="hidden"
            statePath={state =>
              state.customForm.addOrEdit.sectionsByID[item.id].field.hidden ||
              false
            }
            type="field"
            sectionID={item.id}
          />
          <Checkbox
            label="Read only"
            property="readonly"
            statePath={state =>
              state.customForm.addOrEdit.sectionsByID[item.id].field.readonly ||
              false
            }
            type="field"
            sectionID={item.id}
          />
          <Checkbox
            label="Allow other"
            property="options_allow_other"
            statePath={state =>
              state.customForm.addOrEdit?.sectionsByID?.[item?.id]?.field
                ?.options_allow_other || false
            }
            type="field"
            sectionID={item.id}
          />
          <Warning sectionID={item.id} />
        </ExpansionPanelDetails>
      </ExpansionPanel>
    </div>
  ) : (
    <>
      {item?.label && (
        <h3
          style={{
            marginBottom: 0,
            marginTop: '18.72px',
            fontSize: '18.72px',
            padding: 2,
          }}
        >
          {item.label || null}
          {item?.field?.required && <span style={{ color: 'red' }}>*</span>}
        </h3>
      )}
      {item?.description && (
        <div
          style={{
            marginBottom: 0,
            marginTop: '1.72px',
            fontSize: '12.72px',
            padding: 2,
          }}
        >
          {item.description}
        </div>
      )}
      <div className="vast_field_container">
        {item?.field?.field_options?.map?.((option, idx) => (
          <Fragment key={`custom-form-select-${item.id}-${idx}`}>
            <input
              checked={idxSelected === idx}
              onClick={() => {
                selectIdx(idx)
                selectOther(false)
              }}
              type="radio"
              value={option}
              name={item?.field?.field_name}
              datatype="select"
              id={`${idx}${item?.field?.field_name}`}
            />
            <label htmlFor={`${idx}${item?.field?.field_name}`}>{option}</label>
            <br />
          </Fragment>
        ))}
        {item?.field?.options_allow_other && (
          <>
            <input
              checked={otherSelected}
              type="radio"
              value="other"
              name="other"
              datatype="select"
              onClick={() => {
                selectIdx(null)
                selectOther(true)
              }}
            />
            <label htmlFor="other">Other</label>
            <br />
          </>
        )}
        {otherSelected && (
          <input
            // className={
            //   item?.required ? 'vast_field reach_required' : 'vast_field'
            // }
            type="text"
            name={item?.field?.field_name}
            datatype="text"
            style={{
              width: '100%',
              maxWidth: 500,
              border: '1px solid rgba(0, 0, 0, 0.1)',
              padding: 8,
              marginBottom: 8,
              marginTop: 0,
              borderRadius: 35,
            }}
          />
        )}
      </div>
    </>
  )
}

export default Select
